import { useFela } from 'react-fela';
import { FormattedMessage } from 'react-intl';
import { NavLink } from 'react-router-dom';

import config from '@/config';
import { SecurityAuditIndicator } from '@/modules/security-audit/components/SecurityAuditIndicator';
import { TagManager } from '@/services/utilities';

import * as felaRules from './SecurityAuditSecretsTabs.rules';
import { useScrollOverflow } from './useScrollOverflow';

export const SecurityAuditSecretsTabs = () => {
    const { css } = useFela();

    const { ref, canScrollLeft, canScrollRight } = useScrollOverflow<HTMLDivElement>();

    return (
        <div className={css(felaRules.wrapper)}>
            <div ref={ref} className={css(felaRules.container)}>
                <NavLink to={config.routes.securityAudit} className={css(felaRules.link)} activeClassName='active'>
                    <FormattedMessage id='securityAudit.tabs.securityReport' />
                    <SecurityAuditIndicator />
                </NavLink>
                <NavLink
                    to={config.routes.securityAuditLevel}
                    className={css(felaRules.link)}
                    activeClassName='active'
                    onClick={() => {
                        TagManager.push('view_security_password_strength');
                    }}
                >
                    <FormattedMessage id='securityAudit.tabs.securityLevel' />
                </NavLink>
                <NavLink
                    to={config.routes.securityAuditAge}
                    className={css(felaRules.link)}
                    activeClassName='active'
                    onClick={() => {
                        TagManager.push('view_security_password_age');
                    }}
                >
                    <FormattedMessage id='securityAudit.tabs.securityAge' />
                </NavLink>
                <NavLink
                    to={config.routes.securityAuditLeaks}
                    className={css(felaRules.link)}
                    activeClassName='active'
                    onClick={() => {
                        TagManager.push('view_security_password_leaks');
                    }}
                >
                    <FormattedMessage id='securityAudit.tabs.securityLeaks' />
                </NavLink>
            </div>
            {canScrollLeft && <div aria-hidden className={css(felaRules.fadeLeft)} />}
            {canScrollRight && <div aria-hidden className={css(felaRules.fadeRight)} />}
        </div>
    );
};
